import styled from "styled-components";

export const SelectPeriod = styled.div`

        margin-bottom: 42px;

        
        & h3{
            font-weight: 900;
            font-size: 14px;
            line-height: 16px;
            margin-bottom: 8px;
        }

        & .periodOptions{
            display: flex;
            flex-wrap: wrap;
            list-style-type:none;

        }


        & label{
            /* Auto layout */

                display: flex;
                justify-content: flex-end;
                cursor: pointer;


                padding: 10px 16px;
                margin-right: 17px;



                background: #FFFFFF;
                box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.2);
                border-radius: 4px;

                font-weight: 400;
                font-size: 14px;
                line-height: 20px;


                & input{
                    height: 18px;
                    width: 18px;
                    margin-right: 10px;
                    margin-top: 4px;
                }

                & .date{
                    font-weight: 400;
                    font-size: 12px;
                    line-height: 16px;
                    display: flex;
                    align-items: center;

                    color: #757575;

                    span{
                        margin-right: 4px;
                    }
                }

        }
`

